
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reklama-v-torgovyh-centrah",
      function () {
        return require("private-next-pages/reklama-v-torgovyh-centrah/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reklama-v-torgovyh-centrah"])
      });
    }
  